import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LoginBox from './LoginBox';
import { useAuthenticateUser } from '../../hooks/useAuthenticateUser';
import { useDispatch } from 'react-redux';
import { resetMoodle } from '../../support/slices/moodleSlice';
import { hideReloginModal } from '../../support/slices/uiSlice';

const CiscoSSOCallback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const hasStartedRef = useRef(false);

  const { handleCiscoSSOCallback, clearAuthState } = useAuthenticateUser();

  useEffect(() => {
    dispatch(resetMoodle());
    dispatch(hideReloginModal());
  }, [dispatch]);

  useEffect(() => {
    if (hasStartedRef.current) return;
    hasStartedRef.current = true;

    const run = async () => {
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');
      const errorDescription = urlParams.get('error_description');

      if (error) {
        console.error('[CiscoSSOCallback] OIDC error returned', {
          error,
          errorDescription,
        });
        navigate('/error', { replace: true });
        return;
      }

      if (!code) {
        console.error('[CiscoSSOCallback] Missing code in callback URL');
        navigate('/', { replace: true });
        return;
      }

      if (!state) {
        console.error('[CiscoSSOCallback] Missing state in callback URL');
        navigate('/error', { replace: true });
        return;
      }

      try {
        await handleCiscoSSOCallback(code, state);

        const path = localStorage.getItem('postLoginPath');
        localStorage.removeItem('postLoginPath');

        if (path) {
          navigate(path, { replace: true });
        } else {
          // Land on the app root so HomeElement sends every user to the portal, matching the
          // Salesforce OAuth callback. Previously Cisco SSO users jumped straight to /mssp.
          navigate('/', { replace: true });
        }
      } catch (e) {
        console.error('[CiscoSSOCallback] Callback failed', e);
        clearAuthState();
        navigate('/error', { replace: true });
      }
    };

    run();
  }, [location.search, handleCiscoSSOCallback, navigate, clearAuthState]);

  return (
    <LoginBox
      loading={true}
      buttonText="Login with Cisco SSO"
      loadingText="Completing Cisco SSO login..."
      showButton={false}
      showCiscoOption={false}
    />
  );
};

export default CiscoSSOCallback;